module.exports = __webpack_public_path__ + "static/media/IMG_1494.2200d5ca.JPG";